import { Wrench, ShieldCheck, LifeBuoy, Home } from 'lucide-react';
import ChimneyImage from '../../img/Kitchen-chimney.png';
import CTA from '../Cta';

function ChimneyRepairService() {
    return (
        <div className="chimney-repair-container">
            {/* Hero Section - No content, just introductory information */}
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Expert Chimney Repair Services</h1>
                    <p className="chimney-repair-subtitle">
                        Our expert chimney repair services are designed to restore the performance of your chimney, ensuring it operates safely and efficiently. Whether it's a minor issue or a major repair, we are here to help maintain the safety of your home. Chimney problems, if left unchecked, can lead to serious safety hazards, including fire risks and poor ventilation.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Trust our certified technicians to provide a reliable and affordable chimney repair service, tailored to meet the specific needs of your home. From inspection to repair and maintenance, we deliver comprehensive chimney solutions, guaranteeing long-lasting performance and safety.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Regular maintenance and timely repairs can significantly extend the life of your chimney and prevent costly damage. We offer full-service repairs including cleaning, sealing, lining, and the restoration of your chimney’s structural integrity. Our team is equipped with the latest tools and knowledge to handle all chimney-related issues.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Don't wait for a problem to escalate. Our chimney services are designed to address even the smallest issues before they become major concerns. Let us help you keep your home safe, warm, and efficient with our expert chimney repair services.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:70390 34000")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={ChimneyImage} alt="" />
            </div>


            {/* Section 1: Why Choose Us */}
            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Chimney Repair Service?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Wrench size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Skilled Technicians</h3>
                            <p className="chimney-repair-description">
                                Our technicians are experts trained in the latest chimney repair techniques.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Safety First</h3>
                            <p className="chimney-repair-description">
                                We prioritize safety—ensuring your chimney repair adheres to all safety standards.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <LifeBuoy size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Emergency Repairs</h3>
                            <p className="chimney-repair-description">
                                Available 24/7 to fix any urgent chimney issues and restore your home’s comfort.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Affordable Solutions</h3>
                            <p className="chimney-repair-description">
                                We offer cost-effective repair options without compromising on quality.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Our Process */}
            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Chimney Repair Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Our team conducts a thorough inspection to diagnose the issue and recommend the best solution.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Repair Plan</h3>
                        <p className="chimney-repair-step-description">
                            We provide you with a clear repair plan and cost estimate, ensuring transparency.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Efficient Repair</h3>
                        <p className="chimney-repair-step-description">
                            Our skilled technicians repair your chimney quickly, with minimal disruption to your daily life.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Final Check</h3>
                        <p className="chimney-repair-step-description">
                            We complete a final check to ensure your chimney is operating safely and efficiently.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default ChimneyRepairService;
